import { format } from 'date-fns'
import helper from './helper'
import axios from '@/axios'


export default {
  async getByChannel(id, start_time, end_time) {
    return await helper.post(`/api/schedules/by-channel`, {
      channel_id: id,
      start_time,
      end_time
    })
  },
  async add(item) {
    return await helper.post(`/api/schedules`, item)
  },
  async update(item) {
    return await helper.put(`/api/schedules`, item)
  },
  async remove(item) {
    return await helper.delete(`/api/schedules/${item.id}`)
  },
  async removeMultiple(ids) {
    return await helper.post(`/api/schedules/remove-multiple`, { ids: ids })
  },
  async exportEpg(id, start_time, end_time, channelName) {
    const response = await axios({
      url: `/api/schedules/export-epg?channel_id=${id}&start_time=${start_time}&end_time=${end_time}`,
      method: 'GET',
      responseType: 'blob',
    })
    const fileURL = window.URL.createObjectURL(new Blob([response.data]));
    const fileLink = document.createElement('a');

    fileLink.href = fileURL;
    fileLink.setAttribute('download', `epg-${encodeURIComponent(channelName)}-${format(start_time, 'ddMMyy')}-${format(end_time, 'ddMMyy')}.xml`);
    document.body.appendChild(fileLink);

    fileLink.click();
  },
  async exportNielsen(id, start_time, end_time, channelName) {
    const response = await axios({
      url: `/api/schedules/export-nielsen?channel_id=${id}&start_time=${start_time}&end_time=${end_time}`,
      method: 'GET',
      responseType: 'blob',
    })
    const fileURL = window.URL.createObjectURL(new Blob([response.data]));
    const fileLink = document.createElement('a');

    fileLink.href = fileURL;
    fileLink.setAttribute('download', `nielsen-${encodeURIComponent(channelName)}-${format(start_time, 'ddMMyy')}-${format(end_time, 'ddMMyy')}.xlsx`);
    document.body.appendChild(fileLink);

    fileLink.click();
  },
  async exportBreak(id, start_time, end_time, channelName) {
    const response = await axios({
      url: `/api/schedules/export-break?channel_id=${id}&start_time=${start_time}&end_time=${end_time}`,
      method: 'GET',
      responseType: 'blob',
    })
    const fileURL = window.URL.createObjectURL(new Blob([response.data]));
    const fileLink = document.createElement('a');

    fileLink.href = fileURL;
    fileLink.setAttribute('download', `break-${encodeURIComponent(channelName)}-${format(start_time, 'ddMMyy')}-${format(end_time, 'ddMMyy')}.csv`);
    document.body.appendChild(fileLink);

    fileLink.click();
  },
  async exportPlayout(id, date, channelName) {
    const response = await axios({
      url: `/api/schedules/export-playout?channel_id=${id}&date=${date}`,
      method: 'GET',
      responseType: 'blob',
    })
    const fileURL = window.URL.createObjectURL(new Blob([response.data]));
    const fileLink = document.createElement('a');

    fileLink.href = fileURL;
    fileLink.setAttribute('download', `playout-${encodeURIComponent(channelName)}-${format(date, 'ddMMyy')}.csv`);
    document.body.appendChild(fileLink);

    fileLink.click();
  },
  async exportProduction(id, start_time, end_time, channelName) {
    const response = await axios({
      url: `/api/schedules/export-production?channel_id=${id}&start_time=${start_time}&end_time=${end_time}`,
      method: 'GET',
      responseType: 'blob',
    })
    const fileURL = window.URL.createObjectURL(new Blob([response.data]));
    const fileLink = document.createElement('a');

    fileLink.href = fileURL;
    fileLink.setAttribute('download', `production-${encodeURIComponent(channelName)}-${format(start_time, 'ddMMyy')}-${format(end_time, 'ddMMyy')}.xlsx`);
    document.body.appendChild(fileLink);

    fileLink.click();
  },
  async exportCatchup(id, start_time, end_time, channelName) {
    const response = await axios({
      url: `/api/schedules/export-catchup?channel_id=${id}&start_time=${start_time}&end_time=${end_time}`,
      method: 'GET',
      responseType: 'blob',
    })
    const fileURL = window.URL.createObjectURL(new Blob([response.data]));
    const fileLink = document.createElement('a');

    fileLink.href = fileURL;
    fileLink.setAttribute('download', `catchup-${encodeURIComponent(channelName)}-${format(start_time, 'ddMMyy')}-${format(end_time, 'ddMMyy')}.xlsx`);
    document.body.appendChild(fileLink);

    fileLink.click();
  },
  async fetchSequence(id) {
    return await helper.get(`/api/schedule-repeats/${id}`)
  },
  async fetchSequenceItems(id) {
    return await helper.get(`/api/schedule-repeats/items/${id}`)
  },
  async deleteSequence(id) {
    return await helper.delete(`/api/schedule-repeats/${id}`)
  },
  async updateSequenceTitle(item) {
    return await helper.put(`/api/schedules/sequence-title`, item)
  },
  async copySequence(item) {
    return await helper.post(`api/schedules/sequence-copy`, item)
  },
  async copyWeek(item) {
    return await helper.post(`api/schedules/copy-week`, item)
  }
}
